import { get } from './request'

//请求专题
const getProject = get('/Index/topic_json')

export {
    getProject
}